export const PART_MAPPING = [
  {
    id: 'front_bumper_stock',
    fragments: ['front_bumper', 'bumper_plastic'],
    visibility: (state) => state.bumper === 'stock',
    shopifyHandle: "front-bumper-and-bumper-cover-set-2-pc-chrome-for-2007-2013-toyota-tundra-base",
    fallbackName: "Front Bumper and Bumper Cover set 2 pc chrome for 2007-2013 Toyota Tundra Base"
  },
  {
    id: 'rear_bumper_stock',
    fragments: ['id3056'],
    visibility: (state) => state.bumper === 'stock',
    shopifyHandle: "new-rear-chrome-steel-step-bumper-for-2007-2013-toyota-tundra-fleetside",
    fallbackName: "Rear Chrome Steel Step Bumper for 2007-2013 Toyota Tundra, Fleetside"
  },
  {
    id: 'front_bumper_offroad',
    fragments: ['id4434', 'id4231', 'fog_light', 'light_box'],
    visibility: (state) => state.bumper === 'offroad',
    shopifyHandle: "dv8-offroad-14-19-toyota-tundra-front-bumper",
    fallbackName: "DV8 Offroad Front Bumper for 14-19 Toyota Tundra"
  },
  {
    id: 'rear_bumper_offroad',
    fragments: ['rear_bumper001', 'sweep004', 'sweep005', 'sweep1'],
    visibility: (state) => state.bumper === 'offroad',
    shopifyHandle: "dv8-offroad-14-19-toyota-tundra-rear-bumper",
    fallbackName: "DV8 Offroad 14-19 Toyota Tundra Rear Bumper - RBTT2-01"
  },
  {
    id: 'grill_guard',
    fragments: ['grill_guard', 'bush_guard', 'ring', 'id4004'],
    visibility: (state) => state.bumper === 'offroad',
    shopifyHandle: "531000c270-new-grille-grill-for-toyota-tundra-2012-2013",
    fallbackName: "TRD Heritage Grill Guard"
  },
  {
    id: 'winch',
    fragments: ['winch', 'winch_cylinder1', 'cylinder014', 'cube007'],
    visibility: (state) => state.showWinch,
    shopifyHandle: "warn-vr-evo-10-s",
    fallbackName: "Warn VR EVO 10-S Winch"
  },
  {
    id: 'canopy',
    fragments: ['canopy', 'shell', 'camper'],
    visibility: (state) => state.showCanopy,
    shopifyHandle: "smartcap-evo-adventure",
    fallbackName: "SmartCap EVO Adventure"
  },
  {
    id: 'roof_rack',
    fragments: ['rack', 'roof_rack', 'lightbar'],
    visibility: (state) => state.showRack,
    shopifyHandle: null,
    fallbackName: "Roof Rack System"
  },
  {
    id: 'flares',
    fragments: ['flare', 'fender_flare', 'fender', 'screw'],
    visibility: (state) => state.showFlares,
    shopifyHandle: null,
    fallbackName: "Fender Flares"
  },
  {
    id: 'grill',
    fragments: ['toyota_logo001', 'chrome_grill'],
    visibility: (state) => state.showGrill,
    shopifyHandle: null,
    fallbackName: "Front Grill"
  }
];
